import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiVideo, FiExternalLink } from 'react-icons/fi';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const WebinarLandingPage: React.FC = () => {
  useDocumentTitle('Webinar - Mirani Marketing');

  useEffect(() => {
    // Immediate redirect to external webinar page
    window.location.replace('https://miranimarketing.com/webinar');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-600 flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-0white rounded-2xl shadow-2xl p-12 max-w-2xl text-center"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <FiVideo className="text-4xl text-white" />
        </motion.div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Redirecting to Webinar...
        </h1>
        
        <p className="text-xl text-gray-600 mb-8">
          You will be automatically redirected to our webinar page in a moment.
        </p>

        <a
          href="https://miranimarketing.com/webinar"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all"
        >
          Click Here if Not Redirected
          <FiExternalLink />
        </a>
      </motion.div>
    </div>
  );
};

export default WebinarLandingPage;
